<script>
		
</script>

<main>
	
	<h1>Our Services</h1>
	<hr><br>
	<p class="note">At Shoreline Family Dentistry, we provide dental services which range from routine checks to cosmetics to emergency procedures. We are able to provide these services with maximum precision and effectiveness through the use of the latest technologies.</p>
	
	<br>
	<div class="row">
		<div class="column">
			<br>
			<b>We provide services which include:</b>
			<ul>
				<li>Implants</li>
				<li>Cosmetic Dentistry</li>
				<li>Crowns and Bridges</li>
				<li>General Dentistry</li>
				<li>Oral Surgery</li>
				<li>Root Canal Treatments</li>
				<li>Dentures and Partials</li>
			</ul>
		</div>
		<div class="column">
			<img src="/assets/2222973.jpg" alt="Tooth Model">
			<img src="/assets/2134183.jpg" alt="Dental Tools">
		</div>
	</div>
	<!--<br><br><hr><br>
	<p class="note"><b>We provide these services with maximum precision and satisfaction through the use of the latest technologies.</b></p>
	<br>
	<div class="row">
		<div class="column">
			<p>CEREC - One Visit Dentistry and Laser Dentistry</p>
		</div>
		<div class="column">
			<img src="/assets/5182650.jpg" alt="Cerec Logo">
		</div>
	</div>-->
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}

	ul{
		text-align: left;
		position: relative;
		left: 60px;
		top: 10px;
	}

	.note {
		padding: 0px 100px;
	}

	.row {
  		display: flex;
		background-color: aliceblue;
		padding: 3em 3em;
		border-radius: 15px;
	}

	.column {
		flex: 50%;
		font-size: 20px;
	}
</style>